module.exports = __webpack_public_path__ + "static/plaque-bg-2463fe572c023b4b93a089f4d67707dd.png";